import { render, staticRenderFns } from "./Matrix.vue?vue&type=template&id=3bc3b612&scoped=true&"
import script from "./Matrix.vue?vue&type=script&lang=js&"
export * from "./Matrix.vue?vue&type=script&lang=js&"
import style0 from "./Matrix.vue?vue&type=style&index=0&id=3bc3b612&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc3b612",
  null
  
)

export default component.exports